import React, { useState, useEffect } from 'react';
import { enable2FA, disable2FA } from '../../../services/two-factor-auth-service';
import StorageHelper from '../../../utils/storage-helper';

const TwoFactorSettingsModal = ({ visible, onHide, toast }) => {
  const [loading, setLoading] = useState(false);
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);

  useEffect(() => {
    if (visible) {
      const profile = StorageHelper.get('userProfile');
      if (profile && profile.twoFactorEnabled !== undefined) {
        setIs2FAEnabled(profile.twoFactorEnabled);
      }
    }
  }, [visible]);

  const handleToggle = async () => {
    setLoading(true);
    try {
      if (is2FAEnabled) {
        await disable2FA();
        setIs2FAEnabled(false);
        updateProfileStorage(false);
        toast.current.show({ severity: 'success', summary: 'Success', detail: '2FA has been disabled.', life: 3000 });
      } else {
        await enable2FA();
        setIs2FAEnabled(true);
        updateProfileStorage(true);
        toast.current.show({ severity: 'success', summary: 'Success', detail: '2FA has been enabled.', life: 3000 });
      }
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || 'Failed to update 2FA settings.',
        life: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  const updateProfileStorage = (enabled) => {
    const profile = StorageHelper.get('userProfile');
    if (profile) {
      profile.twoFactorEnabled = enabled;
      StorageHelper.set('userProfile', profile);
    }
  };

  return (
    <dialog className={`modal modal-bottom sm:modal-middle ${visible ? 'modal-open' : ''}`}>
      <div className="modal-box rounded-3xl">
        <h3 className="font-bold text-xl text-base-content mb-2">Two-Factor Authentication</h3>
        <p className="text-sm text-base-content/70">
          Two-Factor Authentication (2FA) adds an extra layer of security to your account.
          When enabled, you will be required to enter a 6-digit code sent to your email and phone whenever you log in.
        </p>

        <div className="mt-4 text-sm">
          <span className="font-bold">Current Status: </span>
          <span className={`badge ${is2FAEnabled ? 'badge-success' : 'badge-error'} badge-outline ml-1`}>
            {is2FAEnabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>

        <div className="modal-action">
          <button type="button" className="btn btn-ghost rounded-full" onClick={onHide} disabled={loading}>
            Close
          </button>
          <button
            type="button"
            className={`btn rounded-full text-white border-none ${is2FAEnabled ? 'btn-error' : 'bg-[#135A9C] hover:bg-[#0f4b82]'}`}
            onClick={handleToggle}
            disabled={loading}
          >
            {loading ? <span className="loading loading-spinner loading-sm" /> : null}
            {loading ? 'Processing...' : (is2FAEnabled ? 'Disable 2FA' : 'Enable 2FA')}
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button type="button" onClick={onHide}>close</button>
      </form>
    </dialog>
  );
};

export default TwoFactorSettingsModal;
